const initState = {
    printer: undefined,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'ON_LOAD_PRINTER':
            return { ...state, printer: action.payload }
        case 'ON_CHANGE_PRINTER':
            const result = {
                ...state,
                printer: {
                    ...state.printer,
                    PaperSize: action.payload.PaperSize || state.printer.PaperSize,
                    PrintingOptionIN: action.payload.PrintingOptionIN || state.printer.PrintingOptionIN
                },
            }
            return result
        case 'ON_SAVE_PRINTER': {
            return { ...state, loading_save: true }
        }
        case 'SAVE_PRINTER_SUCCESS':
            return { ...state, save_success_visible: true, loading_save: false }
        case 'SAVE_PRINTER_FAILURE':
            return { ...state, save_failure_visible: true, loading_save: false }
        case 'ON_OK_PRINTER': {
            return {
                ...state,
                save_success_visible: false,
                save_failure_visible: false,
            }
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/settingPrinterReducer.js